const paymentConfig = {
    stripeKey: '', 
  };
  
  export {paymentConfig};
  